<template lang="pug">
header.tiny
  b-navbar(ref="navbar")
    b-navbar-brand.mx-auto(href="/")
      img.brand-logo(src="../../assets/images/logo.svg",alt="logo",:title="app.name")
</template>

<script>
export default {
  data () {
    return {
      app: {
        name: process.env.VUE_APP_NAME
      },
      mask: false
    }
  },
  watch: {
    '$parent.mask' (val) {
      this.mask = this.$parent.mask
    }
  },
  async created () {
    this.$store.commit('setDirectory', this.$route.params.directory)
    this.$root.directory = this.$route.params.directory
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
header.tiny
  nav
    height 60px
    background #FFF
</style>

<style lang="stylus">
.single
  background #FAFAFA
  .message
    position absolute
    top 60px
    width 100%
    min-width 991px !important
    text-align center
    vertical-align middle
    height 80px
    background-color #5d3ea0
    background url("../../assets/images/bgMessage.svg")
    background-size cover
    background-repeat no-repeat
    background-position center center
    p
      color white
      font-size 1.125rem
      font-weight 600
      position absolute
      top 50%
      left 50%
      transform translateY(-50%) translateX(-50%)

  .btn-primary
    border-radius 30px
    padding 0 2rem
    height 50px
    background transparent linear-gradient(268deg, #E04242 0%, #EB622D 100%) 0% 0% no-repeat padding-box
    border 0 none
    span
      color white
      font-size 14px
      font-weight 600

    &:active
    &:focus
      background transparent linear-gradient(268deg, #E04242 0%, #EB622D 100%) 0% 0% no-repeat padding-box

  .container
    min-height calc(100vh - 60px)
    position relative
    .box
      width 30rem
      position absolute
      margin auto
      left 0
      right 0
      top 50%
      transform translateY(-50%)
      .header
        .title
          font-size 22px
          font-weight 600

      .btn-primary
        width 80%

    .form
      h3
        font-size 1.125rem
        padding-bottom 1rem
        margin-bottom 1rem
        border-bottom 1px solid #ccc

      .btn-primary
        width 40%
</style>
